import { Row, Col, Table, Container } from "reactstrap";
import { Link } from "react-router-dom";
import SchoolMap from "./SchoolMap";
import { useContext, useEffect, useState } from "react";
import { SchoolContext } from "../../context/SchoolContext";
import Spinner from "../../commons/Spinner";
import { getPlaceInfo } from "../../api/api";

const SchoolDetail = () => {

    const { setSchool } = useContext(SchoolContext);
    const [selected, selectOnMap] = useState(null);
    const authToken = localStorage.getItem('accessToken');
    const [place, setPlace] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    // useEffect(() => {
    //     if (schoolList.length === 0) {
    //         setIsLoading(true);
    //     }
    //     setIsLoading(false);
    // }, [schoolList]);

    useEffect(() => {
        setIsLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;
        const fetchPlaceInfo = async (signal) => {
            const data = await getPlaceInfo(authToken, signal);
            setPlace(data);
            setIsLoading(false);
        }
        const interval = setInterval(() => {
            fetchPlaceInfo(signal);
        }, 60000);
        fetchPlaceInfo(signal);

        return () => {
            clearInterval(interval);
            controller.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return <Container fluid className="school-detail" >
        <Row>
            {isLoading ? <Col> <Spinner /></Col> : <>

                <Col md={{ size: 7 }} className="mt-1">
                    <Table responsive size="sm" className="summary__table">
                        <thead>
                            <tr>
                                <th>番号</th>
                                <th>発電所名</th>
                                <th>状態</th>
                                <th>発電電力[㎾]</th>
                            </tr>
                        </thead>
                        <tbody>

                            {place.map((data, i) => <tr key={i} >
                                <td className="text__link" onClick={() => selectOnMap(i)} > {data.id}</td>
                                <td className='text__link'>
                                    <Link to={`/home/dashboard/${data.id}`} onClick={() => { setSchool(+data.id) }}
                                        onContextMenu={() => {
                                            setSchool(+data.id)
                                        }}
                                    >
                                        {`${data.user_name}`}
                                    </Link>
                                </td>
                                <td>{data && data.place_status !== null ? data.place_status : "---"}</td>
                                <td>{data && data.generating !== null ? (data.generating / 1000)?.toFixed(2) : "---"}</td>

                            </tr>)}
                        </tbody>

                    </Table>
                </Col>
                <Col md={5}>
                    <SchoolMap selected={selected} />
                </Col>


            </>}
        </Row>
    </Container>
};

export default SchoolDetail;